__turbopack_context__.v({
  "fade-in": "FilterList-module-scss-module__5m-n-G__fade-in",
  "item": "FilterList-module-scss-module__5m-n-G__item",
  "list": "FilterList-module-scss-module__5m-n-G__list",
  "no-transform": "FilterList-module-scss-module__5m-n-G__no-transform",
  "rotate": "FilterList-module-scss-module__5m-n-G__rotate",
  "wrapper": "FilterList-module-scss-module__5m-n-G__wrapper",
});
